import type { PropsWithChildren } from "react"
import { Divider, Typography } from "@mui/material"
import type { SxProps, Theme } from "@mui/material/styles"

import { SectionCardHeader as HeaderContainer } from "widgets/styled/containers"

export const SectionCardHeader = ({ children }: PropsWithChildren) => {
  return (
    <>
      <HeaderContainer>
        <Typography variant="h6" component="h4">
          {children}
        </Typography>
      </HeaderContainer>
      <Divider />
    </>
  )
}

export const Subtitle = ({ children }: PropsWithChildren) => {
  return (
    <>
      <Typography variant="h6" component="h6" sx={{ py: 1 }}>
        {children}
      </Typography>
    </>
  )
}

interface ContainerPropsWithSx {
  sx?: SxProps<Theme>
}

export const Paragraph = ({ children, sx }: PropsWithChildren<ContainerPropsWithSx>) => {
  return (
    <>
      <Typography
        color="text.secondary"
        component="p"
        fontWeight={300}
        sx={{ pb: 1, textAlign: "justify", ...sx }}
      >
        {children}
      </Typography>
    </>
  )
}

export const Itemize = ({ children }: PropsWithChildren) => {
  return (
    <>
      <Typography
        color="text.secondary"
        component="ul"
        fontWeight={300}
        sx={{ pb: 2, textAlign: "justify", marginLeft: "1rem" }}
      >
        {children}
      </Typography>
    </>
  )
}
